import { isThumbnailsNavigationOpened } from '../thumbnails/selectors'
import { hasToAutoDisplayThumbnails } from '../thumbnails/selectors'
import { closeAllLeftAsides } from '../aside/actions'

export function toggleThumbnailsNavigation()
{
    return function toggleThumbnailsNavigation(dispatch, getState)
    {
        if(isThumbnailsNavigationOpened(getState()))
        {
            dispatch(closeThumbnailsNavigation())

            return
        }

        dispatch(openThumbnailsNavigation())
    }
}

export const OPEN_THUMBNAILS_NAVIGATION = 'OPEN_THUMBNAILS_NAVIGATION'
export function openThumbnailsNavigation()
{
    return function openThumbnailsNavigation(dispatch)
    {
        dispatch(closeAllLeftAsides())
        dispatch({ type: OPEN_THUMBNAILS_NAVIGATION})
    }
}

export const CLOSE_THUMBNAILS_NAVIGATION = 'CLOSE_THUMBNAILS_NAVIGATION'
export const closeThumbnailsNavigation = () => ({ type: CLOSE_THUMBNAILS_NAVIGATION})

export function autoDisplayThumbnails()
{
    return function autoDisplayThumbnails(dispatch, getState)
    {
        if(hasToAutoDisplayThumbnails(getState()))
        {
            dispatch(toggleThumbnailsNavigation())
        }
    }
}
